export default "__VITE_ASSET__C2rIMF8m__"